module.exports = __webpack_public_path__ + "assets/img/thumb-FormPiper-Landing-Page-+-Website.1bb34b07.jpg";